import { render, staticRenderFns } from "./QuantumSafeDemo.vue?vue&type=template&id=2440ad4c&scoped=true"
import script from "./QuantumSafeDemo.vue?vue&type=script&lang=js"
export * from "./QuantumSafeDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2440ad4c",
  null
  
)

export default component.exports